import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { SelectOption } from './select-option';

function OptionGroupContainer({
  shouldShowTitles,
  optionGroup,
  titleClassName,
  item,
  onChangeOption,
  selectedOptions,
}) {
  const classes = useStyles();
  const [baseValue, setBaseValue] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    if (optionGroup.required_min > 0) {
      const lBaseValue = _.min(
        optionGroup.options
          ?.filter((o) => !o.blocked)
          ?.map((o) => o.price?.value ?? 0)
      );

      setBaseValue(lBaseValue);
    }
  }, [optionGroup]);

  const title = useMemo(() => {
    let result = '';

    if (shouldShowTitles) {
      result = `${optionGroup.name}`;
    }

    return result;
  }, [optionGroup, shouldShowTitles]);

  const hint = useMemo(() => {
    if (
      optionGroup.required_min > 0 &&
      optionGroup.required_max !== optionGroup.required_min
    ) {
      return t('option-group.choose-at-least', {
        amount: optionGroup.required_min,
      });
    }

    return '';
  }, [optionGroup]);

  const handleOnChangeOption = (option, index) => {
    const clone = _.cloneDeep(option);

    if (clone?.price != null) {
      clone.price.value -= baseValue ?? 0;
    }

    onChangeOption?.call(this, optionGroup, clone, index);
  };

  return (
    <div className={classes.container}>
      {shouldShowTitles && (
        <div className={titleClassName}>
          {title} ▸ {hint}
        </div>
      )}

      {selectedOptions?.map((option, index) => (
        <SelectOption
          className={classes.select}
          // eslint-disable-next-line react/no-array-index-key
          key={`${option?.id}-${index}`}
          // position={index + 1}
          index={index}
          // category={category}
          item={item}
          optionGroup={optionGroup}
          baseValue={baseValue}
          option={option}
          options={optionGroup.options}
          onChange={handleOnChangeOption}
        />
      ))}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid white',
    // paddingBottom: layoutDefaults.smallVerticalMargin + 2,
    // marginBottom: layoutDefaults.bigVerticalMargin,
    // borderBottom: '1px solid red',
  },
});

export { OptionGroupContainer };
